/**
 * Ayrıştırma sonucunun ortak biçimi.
 *
 * Sistemin can damarı `certain` alanıdır. `false` olduğunda değer YİNE DE
 * döner — ama arayüz onu soru işaretiyle gösterir ve kullanıcı onaylamadan
 * deftere yazılmaz. Böylece iki uçtan da kaçınırız: ne sessizce yanlış yazmak,
 * ne de kullanıcıyı çıkmaz sokakta bırakmak.
 */
export interface Parsed<T> {
  /** Okunan değer. Hiç okunamadıysa null. */
  readonly value: T | null;
  /** true = kanıtlanmış okuma. false = yerel ayara dayanan tahmin. */
  readonly certain: boolean;
  /** Emin olmama sebebi — kullanıcıya gösterilir. */
  readonly reason?: string;
  /** Diğer makul okuma. Kullanıcıya "bunu mu demek istediniz?" için. */
  readonly alternative?: T;
}

export function sure<T>(value: T): Parsed<T> {
  return { value, certain: true };
}

export function unsure<T>(value: T, reason: string, alternative?: T): Parsed<T> {
  return { value, certain: false, reason, alternative };
}

export function none<T>(reason: string): Parsed<T> {
  return { value: null, certain: false, reason };
}

/**
 * Kullanıcıya sorulması gereken tek durum.
 *
 * İki farklı sonuç birbirine karıştırılmamalı:
 *   value === null              → OKUNAMADI. Çağıran satırı atlar; sorulacak
 *                                 bir şey yok, çünkü seçenek de yok.
 *   value != null && !certain   → İKİ TÜRLÜ OKUNABİLİYOR. Sorulur.
 *
 * İkisini birleştirmek Excel'de görünür bir hataya yol açmıştı: tür
 * belirlenirken boş "Alacak" hücresi de okunuyor, boş hücre okunamadı
 * dönüyor ve satır gereksiz yere işaretleniyordu. Gereğinden fazla soru
 * sormak, uyarıların ciddiye alınmamasına yol açar — o da sessizce yanlış
 * yazmanın uzun yoldan hâlidir.
 */
export function isAmbiguous<T>(r: Parsed<T>): boolean {
  return !r.certain && r.value !== null;
}
